/**
 * @generated SignedSource<<bcc0cc0f86df4508427b656c234c29ba>>
 * @relayHash 70098693ba1c82f5876b86639e5e7339
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1fdd1301213b13c7a53671f5d4a6c200423ef906910b7b5e784abbee4092451b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ContentHeaderUnifiedQuery$variables = {
  contentId: string;
  embeddedContentRender?: string | null | undefined;
  limit?: number | null | undefined;
  spaceKey?: string | null | undefined;
  status?: ReadonlyArray<string | null | undefined> | null | undefined;
  useNewContentTopper?: boolean | null | undefined;
  versionOverride?: number | null | undefined;
};
export type ContentHeaderUnifiedQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly appearancePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
          readonly version: {
            readonly number: number | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly contentProperties: {
        readonly latest: {
          readonly generatedBy: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly emojiTitlePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
          readonly version: {
            readonly number: number | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly history: {
        readonly createdBy: {
          readonly accountId?: string | null | undefined;
          readonly displayName: string | null | undefined;
          readonly profilePicture: {
            readonly path: string;
          } | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
        readonly createdDate: string | null | undefined;
        readonly lastOwnedBy: {
          readonly accountId?: string | null | undefined;
          readonly displayName: string | null | undefined;
          readonly profilePicture: {
            readonly path: string;
          } | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
        readonly ownedBy: {
          readonly accountId?: string | null | undefined;
          readonly displayName: string | null | undefined;
          readonly profilePicture: {
            readonly path: string;
          } | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly metadata: {
        readonly frontend: {
          readonly coverPictureWidth?: string | null | undefined;
          readonly fabricEditorSupported: boolean | null | undefined;
        } | null | undefined;
        readonly lastModifiedDate: string | null | undefined;
        readonly sourceTemplateEntityId: string | null | undefined;
      };
      readonly pageTitlePublished?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
          readonly version: {
            readonly number: number | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly space: {
        readonly homepageId: string | null | undefined;
        readonly id: string | null | undefined;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly status: string | null | undefined;
      readonly subType: string | null | undefined;
      readonly title: string | null | undefined;
      readonly type: string | null | undefined;
      readonly version: {
        readonly by: {
          readonly accountId?: string | null | undefined;
          readonly displayName: string | null | undefined;
          readonly profilePicture: {
            readonly path: string;
          } | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
        readonly contentTypeModified: boolean | null | undefined;
        readonly friendlyWhen: string | null | undefined;
        readonly message: string | null | undefined;
        readonly number: number | null | undefined;
        readonly when: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly contentContributors: {
    readonly count: number | null | undefined;
    readonly isCurrentUserContributor: boolean | null | undefined;
    readonly isOwnerContributor: boolean | null | undefined;
    readonly nodes: ReadonlyArray<{
      readonly accountId?: string | null | undefined;
      readonly displayName: string | null | undefined;
      readonly profilePicture: {
        readonly path: string;
      } | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly space: {
    readonly id: string | null | undefined;
    readonly lookAndFeel: {
      readonly content: {
        readonly header: {
          readonly background: string | null | undefined;
          readonly backgroundAttachment: string | null | undefined;
          readonly backgroundBlendMode: string | null | undefined;
          readonly backgroundClip: string | null | undefined;
          readonly backgroundColor: string | null | undefined;
          readonly backgroundImage: string | null | undefined;
          readonly backgroundOrigin: string | null | undefined;
          readonly backgroundPosition: string | null | undefined;
          readonly backgroundRepeat: string | null | undefined;
          readonly backgroundSize: string | null | undefined;
          readonly borderRadius: string | null | undefined;
          readonly padding: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly headings: ReadonlyArray<{
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined>;
    } | null | undefined;
    readonly theme: {
      readonly themeKey: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ContentHeaderUnifiedQuery = {
  response: ContentHeaderUnifiedQuery$data;
  variables: ContentHeaderUnifiedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "embeddedContentRender"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useNewContentTopper"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionOverride"
},
v7 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "contentId"
},
v8 = [
  {
    "kind": "Variable",
    "name": "embeddedContentRender",
    "variableName": "embeddedContentRender"
  },
  (v7/*: any*/),
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  },
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "versionOverride"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "type"
},
v11 = {
  "kind": "ScalarField",
  "name": "subType"
},
v12 = {
  "kind": "ScalarField",
  "name": "title"
},
v13 = {
  "kind": "ScalarField",
  "name": "status"
},
v14 = {
  "kind": "ScalarField",
  "name": "key"
},
v15 = {
  "kind": "ScalarField",
  "name": "value"
},
v16 = {
  "kind": "ScalarField",
  "name": "number"
},
v17 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v9/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
          (v16/*: any*/)
        ]
      }
    ]
  }
],
v18 = {
  "alias": "appearancePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "content-appearance-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": "properties(key:\"content-appearance-published\")"
},
v19 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v20 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v22 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v23 = [
  (v10/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/)
],
v24 = {
  "alias": "emojiTitlePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "emoji-title-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v25 = {
  "condition": "useNewContentTopper",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "pageTitlePublished",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "page-title-property-published"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v17/*: any*/),
      "storageKey": "properties(key:\"page-title-property-published\")"
    }
  ]
},
v26 = {
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "editor"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v9/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(key:\"editor\")"
},
v27 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "homepageId"
    }
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "message"
},
v29 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v30 = {
  "kind": "ScalarField",
  "name": "when"
},
v31 = {
  "kind": "ScalarField",
  "name": "contentTypeModified"
},
v32 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "generatedBy"
        }
      ]
    }
  ]
},
v33 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "sourceTemplateEntityId"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "fabricEditorSupported"
        },
        {
          "condition": "useNewContentTopper",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "coverPictureWidth"
            }
          ]
        }
      ]
    }
  ]
},
v34 = [
  (v7/*: any*/),
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  }
],
v35 = {
  "kind": "ScalarField",
  "name": "count"
},
v36 = {
  "kind": "ScalarField",
  "name": "isCurrentUserContributor"
},
v37 = {
  "kind": "ScalarField",
  "name": "isOwnerContributor"
},
v38 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "spaceKey"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "concreteType": "Theme",
      "kind": "LinkedField",
      "name": "theme",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "themeKey"
        }
      ]
    },
    {
      "concreteType": "LookAndFeel",
      "kind": "LinkedField",
      "name": "lookAndFeel",
      "plural": false,
      "selections": [
        {
          "concreteType": "MapOfStringToString",
          "kind": "LinkedField",
          "name": "headings",
          "plural": true,
          "selections": [
            (v14/*: any*/),
            (v15/*: any*/)
          ]
        },
        {
          "concreteType": "ContentLookAndFeel",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "concreteType": "ContainerLookAndFeel",
              "kind": "LinkedField",
              "name": "header",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "background"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundAttachment"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundBlendMode"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundClip"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundColor"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundImage"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundOrigin"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundPosition"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundRepeat"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundSize"
                },
                {
                  "kind": "ScalarField",
                  "name": "borderRadius"
                },
                {
                  "kind": "ScalarField",
                  "name": "padding"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v39 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  },
  (v10/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ContentHeaderUnifiedQuery",
    "selections": [
      {
        "args": (v8/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v18/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v23/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": (v23/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "lastOwnedBy",
                    "plural": false,
                    "selections": (v23/*: any*/)
                  }
                ]
              },
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v28/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": (v23/*: any*/)
                  },
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v16/*: any*/),
                  (v31/*: any*/)
                ]
              },
              (v32/*: any*/),
              (v33/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v34/*: any*/),
        "concreteType": "ContentContributors",
        "kind": "LinkedField",
        "name": "contentContributors",
        "plural": false,
        "selections": [
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v23/*: any*/)
          }
        ]
      },
      (v38/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContentHeaderUnifiedQuery",
    "selections": [
      {
        "args": (v8/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v18/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v39/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": (v39/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "lastOwnedBy",
                    "plural": false,
                    "selections": (v39/*: any*/)
                  }
                ]
              },
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v28/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": (v39/*: any*/)
                  },
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v16/*: any*/),
                  (v31/*: any*/)
                ]
              },
              (v32/*: any*/),
              (v33/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v34/*: any*/),
        "concreteType": "ContentContributors",
        "kind": "LinkedField",
        "name": "contentContributors",
        "plural": false,
        "selections": [
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v39/*: any*/)
          }
        ]
      },
      (v38/*: any*/)
    ]
  },
  "params": {
    "cacheID": "70098693ba1c82f5876b86639e5e7339",
    "id": "1fdd1301213b13c7a53671f5d4a6c200423ef906910b7b5e784abbee4092451b",
    "metadata": {},
    "name": "ContentHeaderUnifiedQuery",
    "operationKind": "query",
    "text": "query ContentHeaderUnifiedQuery($contentId:ID!,$spaceKey:String,$versionOverride:Int,$embeddedContentRender:String,$limit:Int,$useNewContentTopper:Boolean=false,$status:[String]){content(id:$contentId,version:$versionOverride,embeddedContentRender:$embeddedContentRender,status:$status){nodes{id,type,subType,title,status,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},space{id,name,homepageId},version{message,by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},metadata{sourceTemplateEntityId,lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}}}},contentContributors(id:$contentId,limit:$limit){count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},space(key:$spaceKey){id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}}"
  }
};
})();

(node as any).hash = "d58bd52d67b335df9d3d40434d235698";

export default node;
